<template>
  <div>
    <v-card :class="classSection" :height="cardHeight">
      <v-card-title>
        <v-avatar :class="classAvatar" size="56">
          <img src="@/assets/target.svg" />
        </v-avatar>
        <span class>{{ selectedProject.status }}</span>
        <span class="caption ml-2">({{ selectedProject.pid.substr(0,5) }})</span>
        <v-spacer></v-spacer>
        <ActionFabButton mode="edit" :cb="() => showDialog()" />
      </v-card-title>
      <div class="section-line"></div>
      <!-- <div :style="scrollAreaHeight" style="background:red"> -->
      <v-card-text>
        <v-row>
          <ul
            v-for="type in selectedProject.types"
            :key="type"
            class="font-italic font-weight-light"
          >
            <li>{{ type }}</li>
          </ul>
        </v-row>
        <v-row dense class="mt-0">
          <v-col cols="6">
            <span class="body-2 font-weight-light lbl">enquiry:</span>
            <span class="body-2">{{ formatDate(selectedProject.dateEnquiry) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="body-2 font-weight-light lbl">proposal:</span>
            <span class="body-2">{{ formatDate(selectedProject.dateProposal) }}</span>
          </v-col>
        </v-row>
        <v-row dense class="mt-n2">
          <v-col cols="6">
            <span class="body-2 font-weight-light text-left lbl">accepted:</span>
            <span class="body-2 text-left">{{ formatDate(selectedProject.dateAccepted) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="body-2 font-weight-light text-left lbl">start:</span>
            <span class="body-2 text-left">{{ formatDate(selectedProject.dateStarted) }}</span>
          </v-col>
        </v-row>
        <!-- <v-row dense class="mt-n1 project-notes">
            <v-col cols="12">
              <span class="caption text-left">{{ selectedProject.note }}</span>
            </v-col>
        </v-row>-->
      </v-card-text>
      <v-card-text :style="scrollAreaHeight" class="mt-n5">
        <v-row dense class="mt-n1 project-notes">
          <v-col cols="12">
            <span class="caption text-left">{{ selectedProject.note }}</span>
          </v-col>
          <v-col cols="12" v-if="!selectedProject.note">
            <span class="caption text-left">-- no notes --</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="showingDialog" scrollable max-width="500px">
        <DialogProject :obj="obj" />
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import ActionFabButton from "@/components/ActionFabButton";
import { section_Shared } from "./section_Shared";
import { section_Layout } from "./section_Layout";
import { section_Formatting } from "./section_Formatting";
import { section_Dialog } from "./section_Dialog";
import DialogProject from "@/components/dialogs/sections/DialogProject";

export default {
  name: "SectionInfo",
  components: { ActionFabButton, DialogProject },

  setup(props, context) {
    let store = context.root.$store;
    const { selectedProject, createDialogInfoObject } = section_Shared(context);

    const showingDialog = ref(false);
    const obj = ref(null);

    const showDialog = () => {
      let toggle = (b) => (showingDialog.value = b);
      obj.value = createDialogInfoObject();
      obj.value.item = clonePropjectProps(selectedProject.value);
      obj.value.close = () => toggle(false);
      obj.value.update = (project2) => {
        store.dispatch("updateProject", project2);
        toggle(false);
      };
      toggle(true); // open the dialog
    };

    return {
      ...section_Shared(context),
      ...section_Layout(context),
      ...section_Formatting(),
      obj,
      showDialog,
      showingDialog,
    };
  },
};

function clonePropjectProps(project) {
  if (!project) return {};
  return {
    pid: project.pid || "",
    cid: project.cid || "",
    dateAccepted: project.dateAccepted || "",
    dateEnquiry: project.dateEnquiry || "",
    dateProposal: project.dateProposal || "",
    dateStarted: project.dateStarted || "",
    status: project.status || "",
    projectID: project.projectID || "",
    types: project.types || [],
    note: project.note || "",
  };
}
</script>

<style lang="scss" scoped>
.lbl {
  display: inline-block;
  width: 70px;
}
.project-notes {
  // max-height: 75px;
  // overflow-y: auto;
}
</style>